export interface ILayoutSettings {
  columnsSettings: string;
  rowsSettings: string;
  layoutType: LayoutType;
  cardsAreaSettings?: ICardAreaSettings[];
}

export interface ICardAreaSettings {
  column?: string;
  row?: string;
  cardIndex: number;
}

export interface ILayoutList {
  layoutsList: ILayout[];
}

export interface ILayout {
  cardsAmount: number;
  layoutEntity: ILayoutEntity[];
}

export interface ILayoutEntity {
  name: LayoutNameEnum;
  cardsAmount: number;
  formFactor: FormFactor;
}

interface FormFactor {
  rows: number;
  columns: number;
  axis: axis;
  type: type;
}

type axis = LayoutAxis.VERTICAL | LayoutAxis.HORIZONTAL;

export enum LayoutAxis {
  VERTICAL = 'vertical',
  HORIZONTAL = 'horizontal'
}

type type = LayoutType.DEFAULT | LayoutType.CUSTOM;

export enum LayoutType {
  CUSTOM = 'custom',
  DEFAULT = 'default'
}

export enum LayoutNameEnum {
  LAYOUT_ONE_CARD = 'layout-one-card',

  LAYOUT_TWO_CARD_HORIZONTAL = 'layout-two-card-horizontal',
  LAYOUT_TWO_CARD_VERTICAL = 'layout-two-card-vertical',

  LAYOUT_THREE_CARD_HORIZONTAL = 'layout-three-card-horizontal',
  LAYOUT_THREE_CARD_VERTICAL = 'layout-three-card-vertical',
  LAYOUT_THREE_CARD_VERTICAL_CUSTOM_ONE = 'layout-three-card-vertical-custom-one',
  LAYOUT_THREE_CARD_HORIZONTAL_CUSTOM_ONE = 'layout-three-card-horizontal-custom-one',
  LAYOUT_THREE_CARD_HORIZONTAL_CUSTOM_TWO = 'layout-three-card-horizontal-custom-two',
  LAYOUT_THREE_CARD_VERTICAL_CUSTOM_TWO = 'layout-three-card-vertical-custom-two',

  LAYOUT_FOUR_CARD_SQUARE = 'layout-four-card-square',
  LAYOUT_FOUR_CARD_VERTICAL = 'layout-four-card-vertical',
  LAYOUT_FOUR_CARD_HORIZONTAL = 'layout-four-card-horizontal',
  LAYOUT_FOUR_CARD_VERTICAL_CUSTOM_ONE = 'layout-four-card-vertical-custom-one',
  LAYOUT_FOUR_CARD_HORIZONTAL_CUSTOM_ONE = 'layout-four-card-horizontal-custom-one',
  LAYOUT_FOUR_CARD_HORIZONTAL_CUSTOM_TWO = 'layout-four-card-horizontal-custom-two',

  LAYOUT_FIVE_CARD_HORIZONTAL = 'layout-five-card-horizontal',
  LAYOUT_FIVE_CARD_VERTICAL = 'layout-five-card-vertical',

  LAYOUT_SIX_CARD_HORIZONTAL = 'layout-six-card-horizontal',
  LAYOUT_SIX_CARD_VERTICAL = 'layout-six-card-vertical',

  LAYOUT_EIGHT_CARD_HORIZONTAL = 'layout-eight-card-horizontal',
  LAYOUT_EIGHT_CARD_VERTICAL = 'layout-eight-card-vertical'
}
